import request from '@/utils/request'


// 查询时间树事件记录列表
export function listEvent(query) {
  return request({
    url: '/tree/event/list',
    method: 'get',
    params: query
  })
}

// 查询时间树事件记录分页
export function pageEvent(query) {
  return request({
    url: '/tree/event/page',
    method: 'get',
    params: query
  })
}

// 查询时间树事件记录详细
export function getEvent(data) {
  return request({
    url: '/tree/event/detail',
    method: 'get',
    params: data
  })
}

// 新增时间树事件记录
export function addEvent(data) {
  return request({
    url: '/tree/event/add',
    method: 'post',
    data: data
  })
}

// 修改时间树事件记录
export function updateEvent(data) {
  return request({
    url: '/tree/event/edit',
    method: 'post',
    data: data
  })
}

// 删除时间树事件记录
export function delEvent(data) {
  return request({
    url: '/tree/event/delete',
    method: 'post',
    data: data
  })
}
